import { Box, Button, IconButton, Typography } from "@mui/material";
import Table from "components/Table";
import { useState } from "react";
import CreateTask from "./tasks/createTask";
import FloatingButton from "components/FloatingButton";
import { Link } from "react-router-dom";
import moment from "moment";
import { deleteRequestTask, getRequestTasks } from "api/services/tasks";
import { ResType } from "types";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import ViewDescription from "views/task-view/LogHours/ViewDescription";
import EditTask from "./tasks/editTask";
import { useConfirm } from "context/ConfirmDialog";
import AddEvent from "./events/createEvent";
import { deleteRequestEvent, getRequestEvents } from "api/services/events";
import EditEvent from "./events/editEvent";
import ViewEvent from "./events/ViewEvent";

function RequestEvents() {
    const [open, setOpen] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [pageCount, setPageCount] = useState<number>(10);
    const [eventsData, setEventsData] = useState<any>([]);
    const [infoOpen, setInfoOpen] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState("");
    const [totalCount, setTotalCount] = useState<number>(0);

    const { data, isLoading }: ResType = useQuery(
        ["requested-events", { limit: pageCount, offset: page * pageCount, clientId: localStorage.getItem("clientId") || "" }],
        getRequestEvents, {
        onSuccess: (data: any) => {
            setEventsData(data?.data?.[0] || []);
            setTotalCount(data?.data?.[1] || 0);
        },
        onError: (err: any) => {
            if (!err?.error) {
                snack.error(`An error occurred while fetching tasks`);
            }
        }
    }
    );
    const columns = [
        { key: "client", title: "Client", render: (row: any) => row?.client?.displayName || "-" },
        { key: "title", title: "Title", render: (row: any) => row?.title || "-" },
        { key: "location", title: "Location", render: (row: any) => row?.location || "-" },
        { key: "date", title: "Date", render: (row: any) => moment(row?.date).format("DD/MM/YYYY") || "-" },
        { key: "startTime", title: "Start Time & End Time", render: (row: any) => moment(row?.startTime).format("HH:mm") + " - " + moment(row?.endTime).format("HH:mm") || "-" },
        {
            key: "createdAt", title: "Requested At", render: (row: any) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm:ss")
        },
        { key: "actions", title: "Actions", render: (row: any) => row?.event ? <Typography color="green">Event Created</Typography> : <Actions row={row} /> }
    ];

    return <Box>
        <Table
            sx={{ pb: 0, mb: 0, height: "475px" }}
            pagination={{ totalCount, pageCount, setPageCount, page, setPage }}
            data={eventsData || []}
            columns={columns}
        />
        <AddEvent open={open} setOpen={setOpen} />
        <FloatingButton onClick={() => setOpen(true)} />
        <ViewDescription open={infoOpen} setOpen={setInfoOpen} description={selectedDescription} />
    </Box>;
}

const Actions = ({ row }: any) => {
    const [editData, setEditData] = useState<any>(null);
    const [openEdit, setOpenEdit] = useState(false);
    const [viewData, setViewData] = useState<any>(null);
    const [openView, setOpenView] = useState(false);
    const confirm = useConfirm();
    const queryClient = useQueryClient();

    const { mutate, isLoading } = useMutation(deleteRequestEvent, {
        onSuccess: () => {
            snack.success("Event Request Deleted Successfully");
            queryClient.invalidateQueries("requested-events");
        },
        onError: (err: any) => {
            snack.error(err.response.data.message);
        },
    });


    const handleDeleteClick = () => {
        confirm({
            msg: `Are you sure you want to delete this event request ?`,
            action: () => {
                mutate({ id: row.id });
            },
        });
    }

    return <Box>
        <IconButton component={"button"} onClick={() => {
            setViewData(row);
            setOpenView(true);
        }}>
            <Visibility />
        </IconButton>
        <IconButton component={"button"} onClick={() => {
            setEditData(row);
            setOpenEdit(true);
        }}>
            <Edit />
        </IconButton>
        <IconButton component={"button"} onClick={() => {
            handleDeleteClick()
        }}>
            <Delete />
        </IconButton>
        <EditEvent open={openEdit} setOpen={setOpenEdit} data={editData} />
        <ViewEvent open={openView} setOpen={setOpenView} data={viewData} />
    </Box>
}

export default RequestEvents;
